import Breadcrumbs from "../../../components/breadcrumbs";
import CharityIssueCategoryCreateForm from "./ui/charity-issue-category-create-form";

export default function CharityIssueCategoryCreatePage() {
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Charity Issue Categories", href: "/admin/charity-issue-categories" },
          {
            label: "Create",
            href: `/admin/charity-issue-categories/Create`,
            active: true,
          },
        ]}
      />

      <CharityIssueCategoryCreateForm />      
    </main>
  );
}
